import { jsx as _jsx } from "react/jsx-runtime";
import { ProductCatalogPlate } from '@streamr/tv-ui';
import { useMemo } from 'react';
import styled from 'styled-components';
import { PurchaseService } from '../../services/purchase/PurchaseService';
import { BottomRight, Popup } from '../../utils/popups';
import { usePurchasePopupAnchorElementRef } from '../../utils/purchasePopupAnchor';
import { PurchasePopupRoot } from './PurchasePopup';
export function ProductCatalogPopup({ reject, resolve, }) {
    const rawProducts = PurchaseService.getOutput().useProductsOfActiveBroadcast();
    const products = useMemo(() => {
        return rawProducts.map((p) => ({
            ...p,
            tagline: '', // TODO
        }));
    }, [rawProducts]);
    const anchorRef = usePurchasePopupAnchorElementRef();
    return (_jsx(PurchasePopupRoot, { anchorRef: anchorRef, reject: reject, translateFn: BottomRight, "$alignToSidebar": !!anchorRef, children: _jsx(PopupContent, { children: _jsx(ProductCatalogPlate, { onProductClick: (product) => {
                    resolve?.(product);
                }, products: products }) }) }));
}
const PopupContent = styled.div `
    /* Plate */
    --Plate_HeaderPadding: 0 1.5rem;

    padding: 1.5rem 0;
`;
export const productCatalogPopup = Popup.create(ProductCatalogPopup);
